import * as React from "react";

import Grid, { GridSize } from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import type { SxProps } from "@mui/material/styles";
import useTheme from "@mui/material/styles/useTheme";

type PatientReviewDetailProps = {
  title?: string | number | null;
  value?: string | number | null;
  highlighted?: boolean;
  hasBorder?: boolean;
  testId?: string;
  titleTestId?: string;
  valueTestId?: string;
  sx?: SxProps;
  titleSx?: SxProps;
  size?: boolean | GridSize;
  xs?: boolean | GridSize;
  sm?: boolean | GridSize;
  md?: boolean | GridSize;
  lg?: boolean | GridSize;
  style?: any;
};

export default function PatientReviewDetail({
  title,
  value = "",
  sx,
  titleSx,
  hasBorder = true,
  highlighted = false,
  testId,
  titleTestId,
  valueTestId,
  size,
  xs = 12,
  sm = 12,
  md = 6,
  lg = 3,
  style
}: PatientReviewDetailProps) {
  const { palette } = useTheme();
  return (
    <Grid
      item
      sx={sx}
      xs={size ?? xs}
      sm={size ?? sm}
      md={size ?? md}
      lg={size ?? lg}
      border={hasBorder ? "solid 1px #F7F7F7" : "none"}
      boxShadow={hasBorder ? "0px 0px 4px rgb(0 0 0 / 10%)" : "unset"}
      paddingLeft={hasBorder ? 1 : 0}
      paddingTop={hasBorder ? 1 : 0}
      paddingBottom={hasBorder ? 0.5 : 0}
      data-testid={testId ?? "review-detail"}
      style={{
        background: highlighted
          ? palette.patientReviewDetail.selectedBgcolor
          : palette.patientReviewDetail.bgcolor,
        ...style
      }}
    >
      {Boolean(title) || title === 0 ? (
        <Typography
          color={palette.patientReviewDetail.titleColor}
          textTransform="uppercase"
          letterSpacing="0.08em"
          paddingBottom={1}
          data-testid={titleTestId ?? `review-detail-title`}
          sx={titleSx}
        >
          {title}
        </Typography>
      ) : null}

      <Typography
        fontWeight={600}
        paddingBottom={1}
        data-testid={valueTestId ?? `review-detail-value`}
      >
        {value}
      </Typography>
    </Grid>
  );
}
